<div class="fe-capacities-container">
  <div class="table-actions-bar">
    <div class="table-title">CDP Flow Network</div>
    <button (click)="toggleViewMode()" [disabled]="spinnerBoolean || isLoading">
       {{ cdpView ? 'Flat View' : 'CDP View' }}
    </button>
    <button *ngIf="cdpView && selectedRows.length > 0" (click)="clearSelection()" [disabled]="spinnerBoolean || isLoading">
      Clear Select
    </button>
    <button *ngIf="cdpView && hasNewRows()" (click)="cancelEdit()" [disabled]="spinnerBoolean || isLoading">
      Cancel
    </button>
    <button *ngIf="cdpView" (click)="addNewRow()" [disabled]="spinnerBoolean || isLoading || hasNewRows()">
      New
    </button>
    <button *ngIf="hasAnyFilterApplied()" (click)="clearAllFilters()">
      Clear Filters
    </button>
    <button (click)="handleSave()" [disabled]="!data.length">Save</button>
    <button *ngIf="cdpView" (click)="handleDelete()" [disabled]="!selectedRows.length || spinnerBoolean || isLoading">Delete</button>
    <button (click)="openExportDialog()" [disabled]="!data.length">Export</button>
  </div>

  <div class="spinner-container">
    <mat-spinner *ngIf="spinnerBoolean"></mat-spinner>
  </div>

  <div class="table-container" *ngIf="!spinnerBoolean">
    <!-- CDP View (previously Hierarchical View) -->
    <div *ngIf="cdpView" class="hierarchical-table">
      <div class="table-header-container">
        <div class="table-header-row">
          <div class="table-header-cell fixed-width-cell-2 select-column">Select</div>
          <div class="table-header-cell" *ngFor="let col of primaryColumns">
            <div class="col-wrap">
              <div>{{ col.header }}</div>
              <div class="filter-icon-container">
                <ng-container *ngIf="col.field === 'wellPropID'; else defaultFilterIcon">
                  <img class="filter-icon" [ngClass]="{ 'active-filter': (multiFilters[col.field] || []).length > 0 }"
                    src="../../assets/img/search.png" width="16" height="16" alt="Search"
                    (click)="openFloatingFilter($event, col.field)" title="Search {{ col.header }}" />
                </ng-container>
                <ng-template #defaultFilterIcon>
                  <img class="filter-icon" [ngClass]="{ 'active-filter': (multiFilters[col.field] || []).length > 0 }"
                    src="../../assets/img/Filter.png" width="16" height="16" alt="Filter"
                    (click)="openFloatingFilter($event, col.field)" title="Filter {{ col.header }}" />
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-body-container">
        <cdk-virtual-scroll-viewport itemSize="48" minBufferPx="800" maxBufferPx="1000"
          class="virtual-scroll-viewport hierarchical-viewport" (scrolledIndexChange)="onScroll($event)">
          <ng-container *cdkVirtualFor="let row of filteredData; let i = index">
            <div class="table-body-row primary-row">
              <div class="table-header-cell fixed-width-cell-2 select-cell">
                <input
                  type="checkbox"
                  [checked]="selectedRows.includes(row)"
                  (change)="toggleRowSelection(row, $event)"
                />
              </div>
              <div *ngFor="let col of primaryColumns" class="table-header-cell"
                [ngClass]="{
                  'non-editable-cell': !isCellEditable(row, col),
                  'cdp-cell': col.field === 'cdp'
                }">
                
                <ng-container *ngIf="isDropdownCell(row, col); else regularCell">
                  <select 
                    [(ngModel)]="row[col.field]" 
                    [disabled]="!isCellEditable(row, col)"
                    class="custom-dropdown text-wrap cell-wrapper" 
                    [title]="col.field === 'cdp' ? getColumnTooltip(row, col) : (row[col.field] || 'Select an option')"
                    (mouseenter)="col.field === 'cdp' && onCdpHover(row)"
                    (focus)="loadDropdownOptions()"
                    (change)="isCellEditable(row, col) && onDropdownSelectionChange(row, col.field, row[col.field])">
                    <option *ngFor="let option of dropdownOptions[col.field]"
                      [ngValue]="option === '--select--' ? '' : option" [title]="option">
                      {{ option === "--select--" ? "Select" : option }}
                    </option>
                  </select>
                </ng-container>

                <ng-template #regularCell>
                  <div 
                    class="regular-cell text-wrap cell-wrapper"
                    [ngClass]="{ 'non-editable-cell': !isCellEditable(row, col) }"
                    [title]="col.field === 'cdp' ? getColumnTooltip(row, col) : ''"
                    (mouseenter)="col.field === 'cdp' && onCdpHover(row)">
                    {{ row[col.field] || "-" }}
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>

    <!-- Flat View (Original) -->
    <div *ngIf="!cdpView" class="flat-table">
      <div class="table-header-container">
        <div class="table-header-row">
          <div class="table-header-cell" *ngFor="let col of columns">
            <div class="col-wrap">
              <div>{{ col.header }}</div>
              <div class="filter-icon-container">
                <ng-container *ngIf="col.field === 'wellPropID'; else defaultFilterIcon2">
                  <img class="filter-icon" [ngClass]="{ 'active-filter': (multiFilters[col.field] || []).length > 0 }"
                    src="../../assets/img/search.png" width="16" height="16" alt="Search"
                    (click)="openFloatingFilter($event, col.field)" title="Search {{ col.header }}" />
                </ng-container>
                <ng-template #defaultFilterIcon2>
                  <img class="filter-icon" [ngClass]="{ 'active-filter': (multiFilters[col.field] || []).length > 0 }"
                    src="../../assets/img/Filter.png" width="16" height="16" alt="Filter"
                    (click)="openFloatingFilter($event, col.field)" title="Filter {{ col.header }}" />
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-body-container">
        <cdk-virtual-scroll-viewport itemSize="48" minBufferPx="800" maxBufferPx="1000"
          class="virtual-scroll-viewport flat-viewport" (scrolledIndexChange)="onScroll($event)">
          <div class="table-body-row" *cdkVirtualFor="let row of filteredData; let i = index; trackBy: trackByRow">
            <div *ngFor="let col of columns" class="table-header-cell"
              [ngClass]="{
                'non-editable-cell': !isCellEditable(row, col),
                'cdp-cell': col.field === 'cdp'
              }">
              
              <ng-container *ngIf="isDropdownCell(row, col); else regularCell2">
                <select 
                  [(ngModel)]="row[col.field]" 
                  [disabled]="!isCellEditable(row, col)"
                  class="custom-dropdown text-wrap cell-wrapper" 
                  [title]="col.field === 'cdp' ? getColumnTooltip(row, col) : (row[col.field] || 'Select an option')"
                  (mouseenter)="col.field === 'cdp' && onCdpHover(row)"
                  (focus)="loadDropdownOptions()" 
                  (change)="isCellEditable(row, col) && onDropdownSelectionChange(row, col.field, row[col.field])">
                  <option *ngFor="let option of dropdownOptions[col.field]"
                    [ngValue]="option === '--select--' ? '' : option" [title]="option">
                    {{ option === "--select--" ? "Select" : option }}
                  </option>
                </select>
              </ng-container>

              <ng-template #regularCell2>
                <div 
                  class="regular-cell text-wrap cell-wrapper" 
                  [ngClass]="{ 'non-editable-cell': !isCellEditable(row, col) }"
                  [title]="col.field === 'cdp' ? getColumnTooltip(row, col) : ''"
                  (mouseenter)="col.field === 'cdp' && onCdpHover(row)">
                  {{ row[col.field] || "-" }}
                </div>
              </ng-template>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>

  <div class="floating-filter-dropdown" *ngIf="showFloatingFilter" [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }">
    <ng-container *ngIf="activeFilter === 'wellPropID'">
      <input type="text" [(ngModel)]="filterSearch[activeFilter]" placeholder="Search WellPropID..." />
      <div class="filter-buttons">
        <button (click)="applyTextFilter(activeFilter)">Apply</button>
        <button (click)="clearFilter(activeFilter)">Clear</button>
      </div>
    </ng-container>

    <ng-container *ngIf="activeFilter !== 'wellPropID'">
      <input type="text" [(ngModel)]="filterSearch[activeFilter]" placeholder="Search..." />

      <div *ngIf="isLoadingFilterOptions" class="filter-loading">
        <div class="spinner-small"></div>
        Loading options...
      </div>

      <div *ngIf="!isLoadingFilterOptions" class="filter-options">
        <div *ngIf="getFilterOptions(activeFilter).length === 0" class="no-options">
          No options available based on current filters
        </div>
        <div class="filter-options-count" *ngIf="getFilterOptions(activeFilter).length > 0">
          {{ getFilterOptions(activeFilter).length }} options available
        </div>
        <label *ngFor="let option of getFilterOptions(activeFilter)">
          <input type="checkbox" [checked]="isChecked(activeFilter, option)"
            (change)="toggleMultiFilter(activeFilter, option, $event)" />
          <span>{{ getFilterOptionLabel(option) }}</span>
        </label>
      </div>

      <div class="filter-buttons">
        <button (click)="applyFilter(activeFilter)">Apply</button>
        <button (click)="clearFilter(activeFilter)">Clear</button>
      </div>
    </ng-container>
  </div>

  <div *ngIf="isLoading && !cdpView" class="loader-overlay">
    <div class="loader"></div>
  </div>

</div>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export CDP Flow Network</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Delete CDP Flow Network Rows</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>